import { makeStyles } from "tss-react/mui"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faCircleXmark } from "@fortawesome/pro-light-svg-icons"
import { Drawer, Grid, IconButton, Stack, Typography } from "@mui/material"
import { LocalizedStrict } from "../../../../../../modules/localization/components/AppLocalized"
import { AttendeesDrawerContentParse } from "./AttendeesDrawerContentParse"

const useStyles = makeStyles()((theme) => ({
    drawer: {
        zIndex: "1400",
    },
    container: {
        width: "31.25rem",
        padding: "2rem",
        height: "100%",
    },
    title: {
        color: theme.palette.text.primary,
        fontWeight: 700,
    },
    closeButton: {
        padding: "0",
        color: theme.palette.tailwind.slate[500],
    },
}))

type AttendeesDrawerProps = {
    showDrawer: boolean
    handleClose: () => void
}

export function AttendeesDrawer({ showDrawer, handleClose }: AttendeesDrawerProps) {
    const { classes } = useStyles()

    return (
        <Drawer anchor="right" open={showDrawer} onClose={handleClose} className={classes.drawer}>
            <Grid container flexDirection="column" gap="2rem" className={classes.container}>
                <Stack flexDirection="row" justifyContent="space-between">
                    <LocalizedStrict id="create-order-confirm-booking-dialog-bulk-add-attendees-button">
                        <Typography variant="h5" className={classes.title}>
                            Copy and paste
                        </Typography>
                    </LocalizedStrict>
                    <IconButton onClick={handleClose} className={classes.closeButton}>
                        <FontAwesomeIcon icon={faCircleXmark} fontSize={25} />
                    </IconButton>
                </Stack>
                <AttendeesDrawerContentParse handleCloseDrawer={handleClose} />
            </Grid>
        </Drawer>
    )
}
